import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useAdsType } from '../useAdsType';
const AnonOrUserUnit = (_param)=>{
    var { anon: Anon, user: User } = _param, rest = _object_without_properties(_param, [
        "anon",
        "user"
    ]);
    const adType = useAdsType();
    if (adType === 'off') {
        return null;
    }
    if (adType === 'user') {
        return /*#__PURE__*/ React.createElement(User, rest);
    }
    return /*#__PURE__*/ React.createElement(Anon, rest);
};
AnonOrUserUnit.displayName = 'AnonOrUserUnit';
export default AnonOrUserUnit;
